import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const EASE = [0.16, 1, 0.3, 1];

// Each top-level page gets its own distinct entrance/exit choreography so
// navigating the site feels cinematic and intentional rather than generic.
const VARIANTS = {
  home: {
    initial: { opacity: 0, scale: 1.04 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.97 },
    transition: { duration: 0.6, ease: EASE },
  },
  galleries: {
    initial: { opacity: 0, y: 48 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -24 },
    transition: { duration: 0.5, ease: EASE },
  },
  services: {
    initial: { opacity: 0, x: 64 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -40 },
    transition: { duration: 0.5, ease: EASE },
  },
  about: {
    initial: { opacity: 0, x: -64 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 40 },
    transition: { duration: 0.5, ease: EASE },
  },
  contact: {
    initial: { opacity: 0, filter: 'blur(10px)' },
    animate: { opacity: 1, filter: 'blur(0px)' },
    exit: { opacity: 0, filter: 'blur(10px)' },
    transition: { duration: 0.45, ease: EASE },
  },
  default: {
    initial: { opacity: 0, y: 16 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -12 },
    transition: { duration: 0.4, ease: EASE },
  },
};

function getVariant(pathname) {
  if (pathname === '/') return VARIANTS.home;
  if (pathname.startsWith('/galleries')) return VARIANTS.galleries;
  if (pathname.startsWith('/services')) return VARIANTS.services;
  if (pathname.startsWith('/about')) return VARIANTS.about;
  if (pathname.startsWith('/contact')) return VARIANTS.contact;
  return VARIANTS.default;
}

export const PageTransition = ({ children }) => {
  const { pathname } = useLocation();
  const variant = getVariant(pathname);

  return (
    <motion.div
      initial={variant.initial}
      animate={variant.animate}
      exit={variant.exit}
      transition={variant.transition}
    >
      {children}
    </motion.div>
  );
};
